import styled from "styled-components";
import {
  palette,
  modularScale,
  borderRadius,
  media,
  pxToRem,
} from "@ottatech/design";

export const ColoredBackground = styled.div<{ color?: string }>`
  background-color: ${({ color }) =>
    color ? color : palette.grayscale.shade200};
  border-radius: ${pxToRem(borderRadius)};
  padding: ${modularScale()} ${modularScale(-2)};
  ${media({ from: "tablet" })`
    padding: ${modularScale()};
  `}
`;
